package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2025_02_22_Day_1
import com.veldekar.components.logs.Log_2025_02_22_Day_2
import com.veldekar.components.logs.Log_2025_02_22_Day_3
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2025-02-22")
@Composable
public fun Log_2025_02_22(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Pretty Alexander Dido",
        ogTitle = "Pretty Alexander Dido",
        date = LocalDate(2_025, 2, 22),
        aiHint = "Description is a reference to a song.",
        ogDescription = "We’ve been through the desert / To find a cow with three names / It felt good to be out of the rain",
        ogImage = "ai/2025-02-22.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-75", dateString = "Newgrowth 75")
        Log_2025_02_22_Day_1()
        SessionDayHeader(dayId = "newgrowth-76", dateString = "Newgrowth 76")
        Log_2025_02_22_Day_2()
        SessionDayHeader(dayId = "newgrowth-77", dateString = "Newgrowth 77")
        Log_2025_02_22_Day_3()
    }
}
